/* eslint-disable import/prefer-default-export */
export const digitParser = (v) => v.replace(/\D/gi, '');
/* eslint-enable */
